import { ReactNode } from 'react';

import { Alignable, Justifiable, Row, View } from '@bytel/trilogy-react';

interface OfferItemBlockProps {
    children: ReactNode;
}

export const OfferItemBlock = ({ children }: Readonly<OfferItemBlockProps>) => {
    return (
        <Row className='has-background-grey-fade rounded-col p-small'>
            <View
                flexable
                justify={Justifiable.SPACE_BETWEEN}
                align={Alignable.ALIGNED_CENTER}
                className='is-fullheight gap-medium'
            >
                {children}
            </View>
        </Row>
    );
};
